<template>
  <base-card class="position-relative">
    <base-heading>Video Playback</base-heading>
    <base-button
      small
      class="position-absolute m-3 download py-2"
      style="right: 0; top: 0"
      :disabled="videoLoading || videoDownloadURL === null"
      @click="onDownloadVideo"
    >
      <font-awesome-icon
        v-if="videoLoading"
        icon="spinner"
        class="mr-2"
        spin
      />
      <base-icon
        v-else
        icon="download"
        class="mr-2"
      />Download Video
    </base-button>
    <base-skeleton v-if="videoThumbnailLoading">
      <div class="d-flex align-items-center">
        <div
          class="skeleton__item mx-1 my-0"
          style="max-width: 100%; height: 16.25rem"
        />
      </div>
    </base-skeleton>
    <img
      v-else-if="videoThumbnailURL"
      :src="videoThumbnailURL"
      alt="play video"
      class="thumb clickable"
      @click="showModal = true"
    >
    <empty
      v-else
      min-height="16.25rem"
      title="No video playback available"
      style="height: 16.25rem"
    />
    <!-- <base-modal
      id="playback-modal"
      title="Video Playback"
      :show-footer="false"
      :show="showModal"
      centered
      @closed="showModal = false"
    >
      <video
        :key="`${src}?w=600&h=600&fit=fill&fill=solid&fill-color=FAF9F7`"
        class="media"
        controls
      >
        <source
          :src="`${src}?w=600&h=600&fit=fill&fill=solid&fill-color=FAF9F7`"
          type="video/mp4"
        >
      </video>
    </base-modal> -->
  </base-card>
</template>

<script>
export default {
  name: 'LivestreamPostVideo',
  data() {
    return {
      showModal: false,
      downloadLoading: false,
    };
  },
  computed: {
    videoLoading() {
      return this.$store.state.appointments.videoLoading;
    },
    videoThumbnailLoading() {
      return this.$store.state.appointments.videoThumbnailLoading;
    },
    videoDownloadURL() {
      return this.$store.state.appointments.videoDownloadURL;
    },
    videoThumbnailURL() {
      return this.$store.state.appointments.videoThumbnailURL;
    },
  },
  mounted() {
    this.$store.dispatch('appointments/getVideoDownloadURL', this.$route.params.appointmentId);
    this.$store.dispatch('appointments/getVideoThumbnailURL', this.$route.params.appointmentId);
  },
  methods: {
    onDownloadVideo() {
      if (!this.videoDownloadURL) {
        console.log('No video download url yet');
        return;
      }
      window.open(this.videoDownloadURL, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.thumb {
  width: 100%;
  margin-top: 46px;
}
::v-deep .card-body, .sl-card {
  height: 100% !important;
}
::v-deep .card-body {
  max-height: 26rem;
}
::v-deep .modal-dialog {
  max-width: unset !important;
  > .modal-content {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
}
.download {
  ::v-deep &.base-button {
    border-color: $black !important;
    color: $black !important;
  }
}
</style>
